import React from "react";
import { ArrowLeft } from "lucide-react";
const UserProfile = ({ chat, onBack }) => {
  return (
    <div className="bg-white rounded-xl">
      {/* Profile Header */}
      <div className="relative chat-profile-bg rounded-3xl h-[200px] mb-0">
        <div className=" flex items-start gap-4 absolute bottom-[-45px] left-5">
          <img
            src={chat.avatar}
            alt={chat.name}
            className="w-[150px] h-[150px] rounded-3xl border-4 border-yellow-400"
          />
          <div>
            <h2 className="text-2xl font-bold text-[#000000]">{chat.name}</h2>
            <p className="text-[#929292] text-sm font-semibold">@{chat.name.toLowerCase().replace(" ", "_")}</p>
            <p className="text-sm text-gray-600">200 Followers</p>
          </div>

        </div>

      </div>
      <div className="flex items-center justify-between relative top-[10px]">
        <div></div>
        <button
          onClick={onBack}
          className="flex items-center text-[#FFFFFF] text-[14px] font-semibold hover:underline bg-[#095228] p-3 rounded-full"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
            <path d="M12 22.5C17.5228 22.5 22 18.0228 22 12.5C22 6.97715 17.5228 2.5 12 2.5C6.47715 2.5 2 6.97715 2 12.5C2 18.0228 6.47715 22.5 12 22.5Z" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
            <path opacity="0.4" d="M13.2602 16.0302L9.74023 12.5002L13.2602 8.97021" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
          </svg> Back to Chat
        </button>
      </div>
      {/* Contact Info */}
      <div className="flex justify-between text-sm text-gray-600 mt-6">
        <div>
          <h4 className="font-normal text-[#797C7B] text-xs mb-2">Email</h4>
          <p className="font-semibold text-[#000E08] text-sm">jhonabraham20@gmail.com</p>
        </div>
        <div>
          <h4 className="font-normal text-[#797C7B] text-xs mb-2">Phone</h4>
          <p className="font-semibold text-[#000E08] text-sm">(320) 555-0104</p>
        </div>
      </div>

      {/* Media Shared */}
      <div className="mt-6">
        <div className="flex items-center justify-between mb-4">
          <h4 className="font-normal text-[#797C7B] text-xs">Media Shared</h4>
          <a href="#" className="text-xs text-[#095228] font-bold underline">View All</a>
        </div>
        <div className="flex gap-3 justify-between">
          <img src="https://via.placeholder.com/100" alt="media" className="rounded-lg w-full" />
          <img src="https://via.placeholder.com/100" alt="media" className="rounded-lg w-full" />
          <img src="https://via.placeholder.com/100" alt="media" className="rounded-lg w-full" />
          <div className="w-full h-24 bg-gray-800 text-white flex items-center justify-center rounded-lg">
            255+
          </div>
        </div>
      </div>
      <div className="flex justify-around mt-6 mb-4">
        <button className="bg-[#EBF8ED] border border-[#095228] text-[#095228] text-base px-6 py-2 rounded-full hover:bg-gray-100 poppins font-semibold w-full mx-5">
          Clear Chat
        </button>
        <button className="bg-[#BE1F2E] text-[#FFFFFF] text-base px-6 py-2 rounded-full hover:bg-red-700 poppins font-semibold  w-full mx-5">
          Block Person
        </button>
      </div>
    </div>

  );
};

export default UserProfile;
